import React, { useContext, useEffect, useState } from "react";
import FlooringNotificationBar from "./NotificationBar";
import FlooringNotificationContent from "./Notifications";
import axios from "../../helpers/axios";

import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../components/PageLoader";
import {
  setAdminNotificationCount,
  setNotificationFilter,
} from "../../redux/slice/adminNotificationSlice";
import { useNavigate } from "react-router-dom";
import { NotificationContext } from "../DashboardLayout";
import { toast } from "react-toastify";
import { CustomLoaderComponent } from "../../components";

const AddPropertyToArray = (data) => {
  return data.map((item) => ({
    ...item,
    label: item?.name,
    key: item?.id,
  }));
};

const FlooringNotificationLayout = () => {
  const accessToken = localStorage.getItem("dealerModuleToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filters = useSelector(
    (state) => state?.adminNotificationFilter?.notificationFilter
  );
  const { setNotificationCount, setFlooringCount } =
    useContext(NotificationContext);
  const settings = useSelector((state) => state.settings);
  const [loading, setLoading] = useState(false);
  const [adminNotifications, setAminNotifications] = useState([]);
  const [totalAdminNotifications, setTotalAdminNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [selecAll, setSelecAll] = useState(false);
  const [isRead, setIsRead] = useState(false);

  const [notificationTabs, setNotificationsTab] = useState([
    { label: "All", key: "" },
    { label: "COE", key: "COE" },
    { label: "PARF", key: "PARF" },
    { label: "BODY ONLY", key: "BODYONLY" },
  ]);
  const [notfBar, setNotfBar] = useState(false);
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(filters)?.length > 0
      ? filters
      : {
          search_key: "",
          sortBy: "31",
          productType: "",
        }
  );
  const [activeTab, setActiveTab] = useState({});

  const OnNotifcationRead = async (type, groupby, from) => {
    let res = await axios.post(
      `admin/flooring/notifications/markRead/${type === "unread" ? 0 : 1}`,
      {
        notification_ids: groupby,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (res?.status < 400) {
      GetAdminNotifications(from);
      toast.success(res.data?.message);
    }
  };

  const setInitialNotification = (adminNotification) => {
    if (adminNotification?.length > 0) {
      const temp = adminNotification?.filter(
        (it) => it?.notification_type !== "application"
      );
      if (adminNotification[0]?.notification_type === "application") {
        let unReadNotification = adminNotification?.filter(
          (it) => it?.read_at === null
        )?.length;
        setFlooringCount(unReadNotification);
      } else {
        let unReadNotification = adminNotification
          ?.filter((id, index) => index !== 0)
          ?.filter((it) => it?.read_at === null)?.length;
        setFlooringCount(unReadNotification);
      }
      if (temp?.length > 0) {
        //console.log("TEMP", temp);
        setSelectedNotification(temp[0]);
        const newState = adminNotification.map((obj) => {
          if (obj.index === temp[0]?.index) {
            return { ...obj, status: 1 };
          }
          return obj;
        });
        setAminNotifications(newState);
        if (temp[0]?.read_at === null) {
          OnNotifcationRead("read", [temp[0]?.id], "initial");
        }
      }
    } else {
      setFlooringCount(0);
    }
  };

  const GetAdminNotifications = async (from) => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `admin/flooring/notifications?search_key=${
          applyFilters?.search_key !== undefined ? applyFilters?.search_key : ""
        }
      &sortOrder=${applyFilters?.sortBy}
      &vehicle_type=${applyFilters?.productType}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (data?.resp_code < 400) {
        const temp = data?.data?.notification;
        setAminNotifications(Object.values(temp).flat());
        setTotalAdminNotifications(Object.values(temp).flat());
        setLoading(false);
        if (from !== "select") {
          setInitialNotification(Object.values(temp).flat());
        }
      }
    } catch (error) {}
  };

  const onSearch = (key) => {
    setTimeout(() => {
      setApplyFilters({
        ...applyFilters,
        search_key: key,
      });
    }, 1000);
  };
  const OnNotificationSelecct = (id) => {
    let temp = adminNotifications?.filter((it) => it?.id == id);
    const newState = adminNotifications.map((obj) => {
      if (obj.index === id) {
        return { ...obj, status: 1 };
      }
      return obj;
    });
    setAminNotifications(newState);
    setFlooringCount(newState?.filter((it) => it?.read_at === null)?.length);
    if (temp?.length > 0 && temp[0]?.notification_type !== "application") {
      setSelectedNotification(temp[0]);
      temp[0]?.read_at == null &&
        OnNotifcationRead("read", [temp[0]?.id], "select");
    } else {
      temp[0]?.read_at == null &&
        OnNotifcationRead("read", [temp[0]?.id], "select");
      setTimeout(() => {
        navigate("/case-detail", { state: { Id: temp[0]?.id } });
      }, 500);
    }
  };

  const MarkNotificationRead = async (type, selectedIDs) => {
    if (type === "ALLRead" || type === "ALLUnread") {
      try {
        const resp = await axios.post(
          `admin/flooring/notifications/markRead/${
            type === "ALLUnread" ? 0 : 1
          }/ALL`,
          {
            notification_ids: selectedIDs,
          }
        );
        if (resp.status < 400) {
          toast.success(resp.data?.message);
          GetAdminNotifications();
          setSelectedNotifications([]);
          setSelecAll(false);
          setIsRead(false);
        }
      } catch (err) {
        toast.error("Notification not read..!");
      }
    } else {
      try {
        const resp = await axios.post(
          `admin/flooring/notifications/markRead/${type === "unread" ? 0 : 1}`,
          {
            notification_ids: selectedIDs,
          }
        );
        if (resp.status < 400) {
          toast.success(resp.data?.message);
          GetAdminNotifications();
          setSelectedNotifications([]);
          setSelecAll(false);
          setIsRead(false);
        }
      } catch (err) {
        toast.error("Notification not read..!");
      }
    }
  };

  const onFilterRead = (type, selectedIds) => {
    MarkNotificationRead(type, selectedIds);
  };

  const onFilterChange = (type, value) => {
    setApplyFilters({
      ...applyFilters,
      [type]: value,
    });
    dispatch(
      setNotificationFilter({
        ...applyFilters,
        [type]: value,
      })
    );
  };

  useEffect(() => {
    if (settings?.loanProviderTypes?.length > 0) {
      // setNotificationsTab(AddPropertyToArray(settings?.loanProviderTypes));
    }
  }, [settings]);

  useEffect(() => {
    const unreadFlooringNotification = adminNotifications?.filter(
      (it) => it?.read_at === null || it?.readt_at === ""
    );
    setFlooringCount(unreadFlooringNotification?.length);
  }, [adminNotifications]);
  useEffect(() => {
    //console.log("applyFilters", applyFilters);
    GetAdminNotifications();
  }, [applyFilters]);

  return (
    <div className="flex w-full">
      {loading && <CustomLoaderComponent />}
      <FlooringNotificationBar
        adminNotifications={adminNotifications}
        OnNotificationSelecct={OnNotificationSelecct}
        notificationTabs={notificationTabs}
        onFilterChange={onFilterChange}
        onSearch={onSearch}
        loading={loading}
        selectedNotification={selectedNotification}
        applyFilters={applyFilters}
        reload={GetAdminNotifications}
        notfBar={notfBar}
        notfBarClose={() => setNotfBar(false)}
        onFilterRead={onFilterRead}
        selectedNotifications={selectedNotifications}
        setSelectedNotifications={setSelectedNotifications}
        selecAll={selecAll}
        setSelecAll={setSelecAll}
        isRead={isRead}
        setIsRead={setIsRead}
      />
      <FlooringNotificationContent
        selectedNotification={selectedNotification}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        notfBar={() => setNotfBar(true)}
      />
    </div>
  );
};

export default FlooringNotificationLayout;
